export function addCalculatedPromotionResult(itemDetail) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_CALCULATED_PROMOTION_RESULT',
                payload: itemDetail
            });
            resolve(true)
        });
    }
};

export const resetCalculatedPromotionResult = () => ({
    type: 'RESET_CALCULATED_PROMOTION_RESULT'
});